import { onError } from "@apollo/client/link/error";

const UNDER_MAINTENANCE_STATUS_CODE = 503;
const redirect_uri = `${process.env.NEXT_PUBLIC_AUTH_URL}/maintenance?client_id=momo`;

export const createMaintenanceCheckLink = () => {
  return onError(({ networkError }) => {
    /*
     * - in演算子を使用して、型の絞り込みをする必要がある
     * https://github.com/apollographql/apollo-link/issues/816#issuecomment-566736217
     */

    if (networkError && "statusCode" in networkError) {
      if (networkError.statusCode === UNDER_MAINTENANCE_STATUS_CODE) {
        window.location.href = redirect_uri;
      }
    }
  });
};
